import * as React from 'react';
import cn from 'clsx';
import { INNER_FOCUS_RING_CLASSNAME } from '@wix/editor-elements-common-utils';

import ClearIcon from '../../../assets/NewClearIcon.svg';

import style from './ClearButton.scss';

interface ClearButtonProps {
  label: string;
  onClick: React.MouseEventHandler;
  clearButtonText: string;
}

export const ClearButton: React.FC<ClearButtonProps> = ({
  onClick,
  label,
  clearButtonText,
}) => {
  return (
    <button
      aria-label={label}
      className={cn(style.root, INNER_FOCUS_RING_CLASSNAME)}
      data-testid="clear-button"
      onClick={onClick}
      type="button"
    >
      <ClearIcon />
      <span className={style.text}>{clearButtonText}</span>
    </button>
  );
};
